// Wording sourced from the CL-1 Additional Enquiries letter and the wording
// dictated by Angelo on the 3 Aug call. Do not reword without sign-off.

export const OPTION_1_WORDING = 'I instruct AVRillo to reduce delays on my case by proceeding with Option 1.'

export const OPTION_2_STATEMENT =
  'I understand that by choosing the higher risk Option 2, my case is more likely to be delayed, and such delays contribute to 1 in 3 buyers in the UK failing to complete. ' +
  'This not only wastes my costs on the first case if it aborts, but can also add up to 8 months’ delay to start again and find a new property. ' +
  'That means me paying for another set of costs, searches, another survey and broker fee for the new property - and I could lose around £5,750.00 if property prices rise by 2.5% (or £11,500.00 if they rise by 5%). ' +
  'I confirm that because AVRillo have made me aware of the less risky Option 1, yet I still choose Option 2, I do so entirely at my own risk. ' +
  'I will not hold AVRillo responsible for any delay, failed move, property price increases or any costs that result from my decision.'

export const OPTION_2_CONFIRM_LABEL = 'I confirm I have read this option and will accept the higher risk of potential loss of £5,750.00 upwards'

export const TWO_WEEK_NOTE =
  "That's fine - we won't disturb you by chasing. We'll wait two weeks for your decision. If we don't hear from you, we'll proceed with Option 1 as our professional analysis indicates this serves your best interests, in line with Law Society and CLC requirements."

export const VIDEO_URL = 'https://d19q5db0isud9i.cloudfront.net/The%20decision%20that%20protects%20your%20purchase%20(2).mp4'

export const FAQS = [
  {
    question: 'Do I have to decide urgently?',
    paragraphs: [
      "It's your choice. Our duty is to warn you that delays added to by Option 2 can contribute to the 30% of buyers failing to move every year (as documented by independent industry data and studies).",
    ],
  },
  {
    question: 'Loss calculation: How did you calculate my potential estimated loss?',
    paragraphs: [
      "This calculation of potential loss is based on your property price. It is a risk you face if you're one of the 1 in 3 buyers who fail to move in England (risking a further 8 month delay by having to start with a new replacement property, at a different price).",
      "Here's the potential calculations to be considered by all buyers:",
    ],
    bullets: [
      "£5,750.00 loss. E.g. if property prices increase by even just 2.5% by the time you complete on your replacement property (it takes an average of 8 months by the time you start and finish on a second property) if you're one of the 30% of buyers who fail first time around. Note: if prices go up by 5% you risk losing £11,500.00.",
      '£1,000 average lost on your first set of legal costs wasted because you have to start again on a new property.',
      '£460 average lost on searches on a new property and other third-party disbursements lost in your first attempt.',
      '£500 average lost on your surveyor fee and possibly your broker fee, which you have to repeat for your second attempt.',
      '£8,000 lost in paying extra rent (only for those renting, and paying rent e.g. at £1,000 a month during the 8 months they are further delayed before their purchase eventually goes through).',
    ],
  },
  {
    question: 'Are you pushing me into taking Option 1?',
    paragraphs: [
      "Definitely not. Like a doctor, our role isn't to protect you from hearing hard truths but to tell you upfront, so you alone decide how much risk you're prepared to take.",
      "It's entirely your choice which option you choose. As specialist conveyancing lawyers, we have the same professional duty as doctors - to advise you of material risks depending on your options, even when that advice may be unwelcome.",
      "That's why this helps us comply with our regulators (Law Society and CLC), who require us to present both best- and worst-case scenarios and let you choose.",
    ],
  },
  {
    question: 'Are there other losses I risk?',
    paragraphs: [
      "Firstly, don't underestimate the stress and frustration of losing the ideal home you chose in the first place and the stress of potentially waiting another 8 months the second time around. According to the Moverly report, 83% of movers suffer anxiety.",
      'Secondly, always factor in how much you want to risk losing if you fail to reach the very reason you chose to move in the first place. Only you will know yours, but these life-changing requirements can range from family reasons to a deadline to get children into a school catchment area, moving closer to your job, or even securing a good price on a property.',
    ],
  },
  {
    question: 'I want Option 1, but what if I forget to reply, or I want to think about it for two weeks?',
    paragraphs: ["That's fine - we won't disturb you by chasing.", 'Instead:'],
    bullets: [
      "We've already done a cost-benefit analysis and found that Option 1 saves time and money overall (including not wasting costs chasing information that may never come).",
      "We'll wait two weeks for your decision. If we don't hear from you, we'll proceed with Option 1 as our professional analysis indicates this serves your best interests, in line with Law Society and CLC requirements.",
    ],
    footer:
      "Why do we approach it this way? Because we've already done our due diligence cost-benefit analysis on your case (as advised by our legal regulators), which shows Option 1 consistently produces better outcomes. Hence, we'll default to the option that best serves your interests based on this analysis unless you choose Option 2.",
  },
  {
    question: 'How good are your conveyancers at finding solutions?',
    paragraphs: [
      "They're amongst the best in England, trained to use modern conveyancing techniques to reduce risk - unlike older methods criticised by Propertymark.",
    ],
  },
  {
    question: 'Will you charge me for all your extra work and time in finding Option 1 solutions?',
    paragraphs: [
      "In short, no. Whilst our legal regulator permits lawyers the ability to charge their clients by an hourly rate for the additional work involved in exploring solutions to problems, such as we've found for you in Option 1 for you, as goodwill we have decided not to charge you for this additional time and work in finding these option 1 solutions but only for implementing your instructions such as arranging indemnity insurance to cover your option 1 solutions.",
    ],
  },
  {
    question: 'Does Option 1 allow me to be fully registered as the owner?',
    paragraphs: [
      'Yes, of course. It allows you to buy the property with legal title and be registered as the owner at the HMLR Land Registry with new title deeds in your name.',
    ],
  },
  {
    question: 'Will my lender be happy with Option 1?',
    paragraphs: [
      'Yes. Just as the Land Registry will be happy, so to will your mortgage lender. Thats because our suggested Option 1 solutions have been carefully considered to ensure they comply with your lender requirements and often allows completion before the mortgage offer deadline expires which option 2 delays can add to that to that risk and add to the risk of your first purchase aborting.',
    ],
  },
  {
    question: 'Are your statistics and claims verified?',
    paragraphs: [
      "Yes. AVRillo are one of England's most awarded conveyancing firms, including recognition from the Sunday Times so we don't say things unless it's based on fact. All our risk assessments and failure rates are based on documented industry data from regulatory bodies and professional organisations.",
    ],
  },
  {
    question: 'How do you train your expert lawyers to find solutions fast?',
    paragraphs: [
      "Over 26 years specialising exclusively in conveyancing, we've invested hundreds of thousands in training our experts to spot risks and solutions quickly - patterns that other lawyers might miss. We carry out regular spot checks and audits to ensure they meet the high expectations we set. That's how we deliver consistent solutions for every client, not just some.",
    ],
  },
  {
    question: 'Which replies or information can be resolved by Option 1?',
    paragraphs: ['These are set out in Part 2 detailed explanation below.'],
  },
]
